var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { observable, action, computed } from "mobx";
var PeriodPartState = /** @class */ (function () {
    function PeriodPartState(multiplier, maxValue, placeholder) {
        this.value = "";
        this.minValue = 0;
        this.multiplier = multiplier;
        this.maxValue = maxValue;
        this.placeholder = placeholder;
    }
    Object.defineProperty(PeriodPartState.prototype, "valueInMinutes", {
        get: function () {
            return this.value ? this.value * this.multiplier : 0;
        },
        enumerable: true,
        configurable: true
    });
    PeriodPartState.prototype.onChange = function (change) {
        this.value = this.getValueFromChange(change);
    };
    PeriodPartState.prototype.getValueFromChange = function (change) {
        return change.target.value !== "" || change.target.checkValidity() ? this.getPeriodValue(change.target.value) : this.value;
    };
    PeriodPartState.prototype.getPeriodValue = function (value) {
        if (value === "") {
            return value;
        }
        if (value.length > 2) {
            value = value.substring(0, 2);
        }
        var newIntValue = +value;
        newIntValue = Math.max(Math.min(newIntValue, this.maxValue), this.minValue);
        return !isNaN(newIntValue) ? newIntValue : "";
    };
    __decorate([
        observable,
        __metadata("design:type", Object)
    ], PeriodPartState.prototype, "value", void 0);
    __decorate([
        computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], PeriodPartState.prototype, "valueInMinutes", null);
    __decorate([
        action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], PeriodPartState.prototype, "onChange", null);
    return PeriodPartState;
}());
export { PeriodPartState };
//# sourceMappingURL=PeriodPartState.js.map